import styled from 'styled-components';

interface TitleProps {
  fontWeight: number;
}

export const Container = styled.div`

`;

export const TitleContainer = styled.div`
  display: flex;
`;

export const Title = styled.h3<TitleProps>`
  white-space: pre-wrap;
  font-size: 28;
  color: ${props => props.theme.colors.text};
  transition: 200ms;
  font-weight: ${props => props.fontWeight};
`;

export const Subtitle = styled.h3`
  white-space: pre-wrap;
  color: ${props => props.theme.colors.text};
  font-weight: 400;
  font-size: 12px;

  color: ${props => props.theme.colors.text};
  transition: 200ms;
`;

